import styled from 'styled-components';

const Container = styled.main`
	position: relative;
`;
export default Container;
